"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Dashboard_1 = require("@twii/bored/lib/model/Dashboard");
var Dashboard_2 = require("./Dashboard");
var ComponentFactory_1 = require("@twii/bored/lib/model/ComponentFactory");
var DashboardWrapper = /** @class */ (function (_super) {
    __extends(DashboardWrapper, _super);
    function DashboardWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this._dashboard = new Dashboard_1.Dashboard();
        _this._setFromProps(_this.props);
        return _this;
    }
    Object.defineProperty(DashboardWrapper.prototype, "dashboard", {
        get: function () {
            return this._dashboard;
        },
        enumerable: true,
        configurable: true
    });
    DashboardWrapper.prototype._setFromProps = function (props) {
        this.dashboard.router = props.router;
        this.dashboard.addApp = props.addApp;
        this.dashboard.loader = props.loader;
        this.dashboard.saver = props.saver;
        this.dashboard.saveDelay = props.saveDelay;
        this.dashboard.componentFactory = props.componentFactory || ComponentFactory_1.ComponentFactory;
    };
    DashboardWrapper.prototype._load = function (props) {
        if (props.loader) {
            this.dashboard.load();
        }
        else if (props.config) {
            this.dashboard.setConfig(this.props.config);
        }
    };
    DashboardWrapper.prototype.componentWillReceiveProps = function (nextProps) {
        this.dashboard.close();
        this._setFromProps(nextProps);
        this._load(nextProps);
    };
    DashboardWrapper.prototype.componentWillMount = function () {
        this._load(this.props);
    };
    DashboardWrapper.prototype.componentWillUnmount = function () {
        this.dashboard.close();
    };
    DashboardWrapper.prototype.render = function () {
        return React.createElement(Dashboard_2.DashboardContainer, { className: this.props.className, dashboard: this.dashboard, host: this.props.host, styles: this.props.styles });
    };
    return DashboardWrapper;
}(React.Component));
exports.DashboardWrapper = DashboardWrapper;
